export const Iso = [
  { country: "FJ", value: "" },
  { country: "TZ", value: "" },
  { country: "EH", value: "" },
  { country: "CA", value: "" },
  { country: "US", value: "" },
  { country: "KZ", value: "" },
  { country: "UZ", value: "" },
  { country: "PG", value: "" },
  { country: "ID", value: "" },
  { country: "AR", value: "" },
  { country: "CL", value: "" },
  { country: "CD", value: "" },
  { country: "SO", value: "" },
  { country: "KE", value: "" },
  { country: "SD", value: "" },
  { country: "TD", value: "" },
  { country: "HT", value: "" },
  { country: "DO", value: "" },
  { country: "RU", value: "" },
  { country: "BS", value: "" },
  { country: "FK", value: "" },
  { country: "NO", value: "" },
  { country: "GL", value: "" },
  { country: "TL", value: "" },
  { country: "ZA", value: "" },
  { country: "LS", value: "" },
  { country: "MX", value: "" },
  { country: "UY", value: "" },
  { country: "BR", value: "" },
  { country: "BO", value: "" },
  { country: "PE", value: "" },
  { country: "CO", value: "" },
  { country: "PA", value: "" },
  { country: "CR", value: "" },
  { country: "NI", value: "" },
  { country: "HN", value: "" },
  { country: "SV", value: "" },
  { country: "GT", value: "" },
  { country: "BZ", value: "" },
  { country: "VE", value: "" },
  { country: "GY", value: "" },
  { country: "SR", value: "" },
  { country: "FR", value: "" },
  { country: "EC", value: "" },
  { country: "PR", value: "" },
  { country: "JM", value: "" },
  { country: "CU", value: "" },
  { country: "ZW", value: "" },
  { country: "BW", value: "" },
  { country: "NA", value: "" },
  { country: "SN", value: "" },
  { country: "ML", value: "" },
  { country: "MR", value: "" },
  { country: "BJ", value: "" },
  { country: "NE", value: "" },
  { country: "NG", value: "" },
  { country: "CM", value: "" },
  { country: "TG", value: "" },
  { country: "GH", value: "" },
  { country: "CI", value: "" },
  { country: "GN", value: "" },
  { country: "GW", value: "" },
  { country: "LR", value: "" },
  { country: "SL", value: "" },
  { country: "BF", value: "" },
  { country: "CF", value: "" },
  { country: "CG", value: "" },
  { country: "GA", value: "" },
  { country: "GQ", value: "" },
  { country: "ZM", value: "" },
  { country: "MW", value: "" },
  { country: "MZ", value: "" },
  { country: "SZ", value: "" },
  { country: "AO", value: "" },
  { country: "BI", value: "" },
  { country: "IL", value: "" },
  { country: "LB", value: "" },
  { country: "MG", value: "" },
  { country: "PS", value: "" },
  { country: "GM", value: "" },
  { country: "TN", value: "" },
  { country: "DZ", value: "" },
  { country: "JO", value: "" },
  { country: "AE", value: "" },
  { country: "QA", value: "" },
  { country: "KW", value: "" },
  { country: "IQ", value: "" },
  { country: "OM", value: "" },
  { country: "VU", value: "" },
  { country: "KH", value: "" },
  { country: "TH", value: "" },
  { country: "LA", value: "" },
  { country: "MM", value: "" },
  { country: "VN", value: "" },
  { country: "KP", value: "" },
  { country: "KR", value: "" },
  { country: "MN", value: "" },
  { country: "IN", value: "" },
  { country: "BD", value: "" },
  { country: "BT", value: "" },
  { country: "NP", value: "" },
  { country: "PK", value: "" },
  { country: "AF", value: "" },
  { country: "TJ", value: "" },
  { country: "KG", value: "" },
  { country: "TM", value: "" },
  { country: "IR", value: "" },
  { country: "SY", value: "" },
  { country: "AM", value: "" },
  { country: "SE", value: "" },
  { country: "BY", value: "" },
  { country: "UA", value: "" },
  { country: "PL", value: "" },
  { country: "AT", value: "" },
  { country: "HU", value: "" },
  { country: "MD", value: "" },
  { country: "RO", value: "" },
  { country: "LT", value: "" },
  { country: "LV", value: "" },
  { country: "EE", value: "" },
  { country: "DE", value: "" },
  { country: "BG", value: "" },
  { country: "GR", value: "" },
  { country: "TR", value: "" },
  { country: "AL", value: "" },
  { country: "HR", value: "" },
  { country: "CH", value: "" },
  { country: "LU", value: "" },
  { country: "BE", value: "" },
  { country: "NL", value: "" },
  { country: "PT", value: "" },
  { country: "ES", value: "" },
  { country: "IE", value: "" },
  { country: "NC", value: "" },
  { country: "SB", value: "" },
  { country: "NZ", value: "" },
  { country: "AU", value: "" },
  { country: "LK", value: "" },
  { country: "CN", value: "" },
  { country: "TW", value: "" },
  { country: "IT", value: "" },
  { country: "DK", value: "" },
  { country: "GB", value: "" },
  { country: "IS", value: "" },
  { country: "AZ", value: "" },
  { country: "GE", value: "" },
  { country: "PH", value: "" },
  { country: "MY", value: "" },
  { country: "BN", value: "" },
  { country: "SI", value: "" },
  { country: "FI", value: "" },
  { country: "SK", value: "" },
  { country: "CZ", value: "" },
  { country: "ER", value: "" },
  { country: "JP", value: "" },
  { country: "PY", value: "" },
  { country: "YE", value: "" },
  { country: "SA", value: "" },
  { country: "CYP", value: "" },
  { country: "CY", value: "" },
  { country: "MA", value: "" },
  { country: "EG", value: "" },
  { country: "LY", value: "" },
  { country: "ET", value: "" },
  { country: "DJ", value: "" },
  { country: "SOM", value: "" },
  { country: "UG", value: "" },
  { country: "RW", value: "" },
  { country: "BA", value: "" },
  { country: "MK", value: "" },
  { country: "RS", value: "" },
  { country: "ME", value: "" },
  { country: "XK", value: "" },
  { country: "TT", value: "" },
  { country: "SS", value: "" },
];
